module.exports = "#version 300 es\n\n\nuniform mat4 u_Model;\nuniform mat4 u_ModelInvTr;\nuniform mat4 u_ViewProj;\nuniform vec2 u_PlanePos; // Our location in the virtual world displayed by the plane\nuniform float u_LavaHeight;\n\nin vec4 vs_Pos;\nin vec4 vs_Nor;\nin vec4 vs_Col;\n\nout vec3 fs_Pos;\nout vec4 fs_Nor;\nout vec4 fs_Col;\n\nvec2 seed = vec2(332.5, 7732.9);\n\nvoid main()\n{\n  fs_Pos = vs_Pos.xyz;\n  vec4 modelposition = vec4(vs_Pos.x, u_LavaHeight, vs_Pos.z, 1.0);\n  modelposition = u_Model * modelposition;\n  gl_Position = u_ViewProj * modelposition;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/lava-vert.glsl
// module id = 82
// module chunks = 0